import type { AdminRole } from '@cornerstone/shared';
import { useAuthMe } from './authMe';

// =============================================================================
// useAdminRole — 관리자 등급 (Figma 권한 다이어그램).
//   h9_super  최고 관리자(H9/BO) : 전 메뉴 + 조직 관리 + H9(고객사 관리)
//   fo_super  조직 관리자(FO)    : + 조직 관리(자기 조직)
//   fo_admin  관리자(FO)         : 미디어/스케줄/디바이스/관리 이력
// /api/auth/me의 adminRole을 그대로 쓴다(서버가 단일 소스, useAuthMe가 한 번만 호출). 로컬 dev(auth off)는
// 서버가 h9_super를 돌려준다. 판정 전('checking')에는 상위 메뉴를 숨겨 깜빡임 방지.
// 단, 일시 장애 때는 마지막 성공 역할을 유지해 메뉴를 조용히 축소하지 않는다. 성공
// 이력이 없는 실패만 최소 권한(fo_admin)으로 둔다.
// =============================================================================

export type AdminRoleState = AdminRole | 'checking';

export function useAdminRole(): AdminRoleState {
  const { loading, me } = useAuthMe();
  if (me) return me.adminRole;
  return loading ? 'checking' : 'fo_admin';
}
